import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import { ArtBaselLogo, Container } from '@mch-group/uikit-components'
import { Media, MediaContextProvider } from '@responsive'

import styles from './styles/index.module.scss'

function MinimalistHeader({ rightSideText, fluid = false, mobileTitle = 'OVR', altTextLabels }) {
  const title = altTextLabels?.megamenuArtBaselLogo
  return (
    <nav aria-label='minimalist-header' className={styles.minimalistHeader}>
      <Container className='px-5 px-lg-8 px-md-7 w-100' fluid={fluid}>
        <div className={styles.SubContainer}>
          <Link href='/' legacyBehavior>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a title={title}>
              <ArtBaselLogo variant='default' color='dark' />
            </a>
          </Link>
          <MediaContextProvider>
            <Media lessThan='computer'>
              <h1 className='h4 color-textgrey'>{mobileTitle}</h1>
            </Media>
            <Media greaterThanOrEqual='computer'>
              <h1 className='h4 color-textgrey'>{rightSideText}</h1>
            </Media>
          </MediaContextProvider>
        </div>
      </Container>
    </nav>
  )
}

MinimalistHeader.propTypes = {
  rightSideText: PropTypes.string,
  mobileTitle: PropTypes.string,
  fluid: PropTypes.bool
}

export default MinimalistHeader
